// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import AssetList from 'views/pages/assets/assetsList';
import NotFoundError from 'views/pages/maintenance/NotFoundError';
import UserList from 'views/pages/users/userList';
import GatewayList from 'views/pages/gateways/gatewayList';
import CheckoutForm from 'ui-component/stripe/CheckoutForm';
import Return from 'ui-component/stripe/Return';
import HalogList from 'views/pages/halog/halogList';
import TagList from 'views/pages/tags/tagsList';
import Dashboard from 'views/pages/dashboard';
import TenantList from 'views/pages/tenants/tenantsList';
import SystemAdminList from 'views/pages/systemAdmin/systemAdminList';
import UserProfile from 'views/pages/userProfile/userProfile';
import GrafanaDashboard from 'views/grafana/grafanaDashboard';
import FirmwareList from 'views/pages/firmware/firmwareList';
import ViewFirmwareDetails from 'views/pages/firmware/viewDetails';
import HalogDetails from 'views/pages/halog/halogDetails';
import AssetDetails from 'views/pages/assets/assetDetails';
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/assets',
            element: <AssetList />,
            roles: ['User', 'Admin']
        },
        {
            path: '/asset',
            element: <AssetDetails />,
            roles: ['User', 'Admin']
        },
        {
            path: '/halogs',
            element: <HalogList />,
            roles: ['Admin']
        },
        {
            path: '/halog',
            element: <HalogDetails />,
            roles: ['Admin']
        },
        {
            path: '/users',
            element: <UserList />,
            roles: ['Admin']
        },
        {
            path: '/gateways',
            element: <GatewayList />,
            roles: ['Sys_Admin']
        },
        {
            path: '/tenants',
            element: <TenantList />,
            roles: ['Sys_Admin']
        },
        {
            path: '/system-admin-users',
            element: <SystemAdminList />,
            roles: ['Sys_Admin']
        },
        {
            path: '/firmwares',
            element: <FirmwareList />,
            roles: ['Sys_Admin']
        },
        {
            path: '/tags',
            element: <TagList />,
            roles: ['User', 'Admin']
        },
        {
            path: '/profile',
            element: <UserProfile />,
            roles: ['User', 'Admin']
        },
        // {
        //     path: '/checkout',
        //     element: <CheckoutForm />,
        //     roles: ['All']
        // },
        // {
        //     path: '/return',
        //     element: <Return />,
        //     roles: ['All']
        // },
        {
            path: '/not_found',
            element: <NotFoundError />,
            roles: ['All']
        },
        {
            path: '/home',
            element: <Dashboard />,
            roles: ['User', 'Admin']
        },
        {
            path: '/view-firmwar-details',
            element: <ViewFirmwareDetails />,
            roles: ['Sys_Admin']
        },
        {
            path: '/grafana-dashboard',
            element: <GrafanaDashboard />,
            roles: ['User', 'Admin']
        },
        {
            path: '*',
            element: <NotFoundError />,
            roles: ['All']
        }
    ]
};

export default MainRoutes;
